import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { IntlFormatters, IntlShape as UntypedIntlShape } from 'react-intl';
import { FormattedMessage as ReactIntlFormattedMessage, useIntl as useReactIntl } from 'react-intl';
import type { Props as ReactIntlFormattedMessageProps } from 'react-intl/src/components/message';
import en from './en';
export { createIntl, createIntlCache, defineMessage, defineMessages, FormattedDate, FormattedDateParts, FormattedDateTimeRange, FormattedDisplayName, FormattedList, FormattedListParts, FormattedNumber, FormattedNumberParts, FormattedPlural, FormattedRelativeTime, FormattedTime, FormattedTimeParts, injectIntl, IntlContext, IntlProvider, InvalidConfigError, MessageFormatError, MissingDataError, MissingTranslationError, RawIntlProvider, ReactIntlError, ReactIntlErrorCode, UnsupportedFormatterError } from 'react-intl';
export type { CustomFormatConfig, CustomFormats, FormatDateOptions, FormatDisplayNameOptions, FormatListOptions, FormatNumberOptions, FormatPluralOptions, FormatRelativeTimeOptions, Formatters, IntlCache, IntlConfig, IntlFormatters, IntlShape as UntypedIntlShape, MessageDescriptor, MessageFormatElement, ResolvedIntlConfig, WithIntlProps, WrappedComponentProps } from 'react-intl';
const messages = {
  en: () => new Promise<{
    default: typeof en;
  }>(resolve => {
    resolve({
      default: en
    });
  }),
  fr: () => import('./fr'),
  cs: () => import('./cs'),
  'de-DE': () => import('./de-DE'),
  'es-ES': () => import('./es-ES'),
  'it-IT': () => import('./it-IT'),
  'nl-NL': () => import('./nl-NL'),
  pl: () => import('./pl'),
  'pt-PT': () => import('./pt-PT')
};
export { messages };
export { en as defaultMessages };
export type IntlMessageKeys = keyof typeof en;

// The arguments to the original formatMessage function.
type FormatMessageArgs = Parameters<IntlFormatters['formatMessage']>;

// Extend the original FormattedMessage props.
// Use the default generic (which includes FormatXMLElementFn for rich-text render functions)
// rather than restricting to Record<string, React.ReactNode>.
type FormattedMessageProps = ReactIntlFormattedMessageProps & {
  id?: IntlMessageKeys;
};
function FormattedMessage(t0) {
  const $ = _c(6);
  let id;
  let rest;
  if ($[0] !== t0) {
    ({
      id,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = id;
    $[2] = rest;
  } else {
    id = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== id || $[4] !== rest) {
    t1 = <ReactIntlFormattedMessage id={id} {...rest} />;
    $[3] = id;
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
type IntlShape = Omit<UntypedIntlShape, 'formatMessage'> & {
  formatMessage(descriptor: FormatMessageArgs[0] & {
    id?: IntlMessageKeys;
  }, values?: FormatMessageArgs[1], options?: FormatMessageArgs[2]): string;
  formatMessage(descriptor: FormatMessageArgs[0] & {
    id?: IntlMessageKeys;
  }, values?: FormatMessageArgs[1], options?: FormatMessageArgs[2]): Array<React.ReactNode>;
};
function useIntl() {
  return useReactIntl();
}
export { useIntl, FormattedMessage, IntlShape };